import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "components/common/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { Formik } from "formik";
import { validate } from "./functions";

const useStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh"
  },
  formError: {
    color: "red"
  },
  logo: {
    width: 120
  },
  formHeader: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column"
  }
});

export default function Login({ login }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Paper>
        <Formik
          initialValues={{ username: "", password: "" }}
          validate={validate}
          onSubmit={async (values, { setSubmitting, setErrors }) => {
            const result = await login(values);
            if (!result.ok) {
              setErrors({ form: result.message });
            }
            setSubmitting(false);
          }}
          noValidate
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting
          }) => (
            <form onSubmit={handleSubmit}>
              <div className={classes.formHeader}>
                <img
                  src="/images/logo.png"
                  className={classes.logo}
                  alt="Camino Connections"
                />
                {errors.form && (
                  <div className={classes.formError}>{errors.form}</div>
                )}
              </div>

              <TextField
                label="Username"
                variant="outlined"
                fullWidth
                margin="normal"
                type="text"
                name="username"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.username || ""}
                error={Boolean(errors.username)}
                helperText={errors.username}
              />
              <TextField
                label="Password"
                variant="outlined"
                fullWidth
                margin="normal"
                type="password"
                name="password"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.password || ""}
                error={Boolean(errors.password)}
                helperText={errors.password}
              />
              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={isSubmitting}
                fullWidth
              >
                Login
              </Button>
            </form>
          )}
        </Formik>
      </Paper>
    </div>
  );
}
